package org.example.project.screens_cus

import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.enginetabular.loadWithTabularFilters
import org.example.project.utils.All

object FirmenstammApi {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun loadEntries(): List<All> {
        val raw = LumaticaApiManager.call("firmenstamm/entries")
        if (raw.isBlank() || raw == "null") return emptyList()
        return runCatching {
            json.decodeFromString(ListSerializer(All.AllNames.serializer()), raw)
        }.getOrDefault(emptyList())
    }

    suspend fun searchEntries(filters: Map<String, String>): List<All> {
        val raw = loadWithTabularFilters("firmenstamm/entries-tabular", filters)
        if (raw.isBlank() || raw == "null") return emptyList()
        return runCatching {
            json.decodeFromString(ListSerializer(All.AllNames.serializer()), raw)
        }.getOrDefault(emptyList())
    }
}
